import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'

import Timeline from 'components/Timeline'
import SectionAccordion from 'components/SectionAccordion'

import { ReactComponent as IconCalendar } from 'assets/icons/IconCalendar.svg'
import { getGroupedMutationsByDate } from 'utils/Orders/getGroupedMutationsByDate'
import { transfromMutationType } from 'utils/Orders/transformMutationType'

const OrderMutationHistory = forwardRef(({ order, id }, ref) => {
  const { mutations } = order

  const sortedMutationsDescending =
    mutations?.sort((a, b) => {
      return new Date(b?.createdAt ?? null) - new Date(a?.createdAt ?? null)
    }) ?? []

  const groupedMutationsByDate = getGroupedMutationsByDate(
    sortedMutationsDescending
  )

  if (isEmpty(mutations)) {
    return null
  }

  return (
    <SectionAccordion title="Mutation History">
      <section id={id} ref={ref}>
        <Timeline>
          {Object.entries(groupedMutationsByDate)?.map(
            ([date, mutations], index) => {
              return (
                <li className="timeline__item" key={index}>
                  <p className="timeline__date">
                    <span className="timeline__calendar-icon">
                      <IconCalendar />
                    </span>
                    {date}
                  </p>
                  <ul className="timeline__details-list">
                    {mutations?.map(
                      ({
                        type,
                        reason,
                        applied,
                        id,
                        applicationMessage,
                        dateAndTime,
                      }) => {
                        const mutationType = transfromMutationType(type)
                        const statusDotColor = applied ? 'green' : 'red'

                        return (
                          <li className="timeline__detail" key={id}>
                            <p className="timeline__header">
                              <span
                                className={`timeline__dot
                                -${statusDotColor}`}
                              ></span>
                              <span>{mutationType ?? ''}</span>
                              <span className="timeline__status-date">
                                {dateAndTime ?? ''}
                              </span>
                            </p>
                            {!isEmpty(applicationMessage) && (
                              <p className="timeline__comment -border-none -p-0">{`Message: ${
                                applicationMessage ?? ''
                              }`}</p>
                            )}
                            {!isEmpty(reason) && (
                              <p className="timeline__comment  -border-none -p-0">{`Reason: ${
                                reason ?? ''
                              }`}</p>
                            )}
                          </li>
                        )
                      }
                    )}
                  </ul>
                </li>
              )
            }
          )}
        </Timeline>
      </section>
    </SectionAccordion>
  )
})

OrderMutationHistory.displayName = 'OrderMutationHistory'

OrderMutationHistory.propTypes = {
  order: PropTypes.object,
  id: PropTypes.string,
}

export default OrderMutationHistory
